import { FC, ReactNode, createContext, useEffect, useState } from 'react';

import { LocationConfig, getLocationData } from '../../api/requests';

import { useConfig } from '@providers/ConfigRedirectProvider';
import {
  DEFAUL_QUIZ_DATA,
  QuizContextType,
  QuizData,
} from './QuizProvider.types';

export const QuizContext = createContext<QuizContextType | null>(null);

export const QuizProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const config = useConfig();
  const configParams = config.params;

  const [step, setStep] = useState(Number(configParams?.startFrom) || 0);
  const [quizData, setQuizData] = useState<QuizData>(DEFAUL_QUIZ_DATA);
  const [userLocation, setUserLocation] = useState<LocationConfig | null>(null);

  useEffect(() => {
    getLocationData()
      .then(response => {
        setUserLocation(response);
      })
      .catch(console.error);
  }, []);

  const value: QuizContextType = {
    step,
    setStep,
    quizData,
    setQuizData,
    userLocation,
  };

  return <QuizContext.Provider value={value}>{children}</QuizContext.Provider>;
};
